export default __webpack_public_path__ + "static/media/noAudits.8a48e96c.png";